import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/project/$projectId')({

}).lazy(() => import('./$projectId.lazy').then((d) => d.Route));
